module.exports = ".tags .close {\r\n  right: auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/think-list-display-search/think-list-display-search.component.css
// module id = ./src/app/components/think-list-display-search/think-list-display-search.component.css
// module chunks = main